import Image from "next/image";
import Form from "./Form";

interface InterestedInFormProps {
  data?: any;
}

export default function InterestedInForm({ data }: InterestedInFormProps) {
  return (
		<section
			id='interested-in-form'
			className='relative w-full px-4'
		>
			<Image
				src='/images/bg-form-new.webp'
				alt='Background Form'
				fill
				className='object-cover object-center absolute inset-0'
				quality={95}
				loading={'lazy'}
			/>
			<div className='relative z-10 h-full'>
				<div className='xl:ml-[50%] mx-auto bg-white w-fit p-8 sm:p-16 max-w-[650px]'>
					<h2 className=' mb-8'>Interested in Plastic Surgery in London?</h2>
					<p>
						Talk about your concerns with a facial cosmetic surgery expert;
						contact us today to schedule an appointment.
					</p>
					<Form />
				</div>
			</div>
		</section>
	)
}
